export const PAYMENT_METHOD = Object.freeze({
    CREDIT_CARD: 'クレジットカード',
    CONVENIENCE_STORE: 'コンビニ決済',
    POSTAL_TRANSFER_SLIP: '郵便振替票',
    BANK_TRANSFER: '銀行等振込',
    SCHOOL_PAYMENT: '園・学校へ支払い'
})

export const DELIVERY_METHOD = Object.freeze({
    YUU_PACKET: 'ゆうパケット便',
    NEKOPOS: 'ネコポス便',
    HOME_DELIVERY: '宅配便',
    SCHOOL_PICKUP: '園・学校受取',
    DATA_ONLY: '配送なし（データ販売）'
})



// WEBPACK FOOTER //
// ./src/constants/orderOption.js